// import { API, graphqlOperation } from "aws-amplify";
// import moment from "moment";
// import { useStateList } from "./HandleInvoiceStateProvider";
// import { billingCurrencyOptions } from "../../../utils/Data/StaticData";
// import {
//   getAccountBalance,
//   getCodeTranslation,
//   getPartyAddressEntity,
//   getPartyInvoices,
//   getPartyMaster,
// } from "../../../graphql";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";

// const usePartyDetails = () => {
//   const {
//     data,
//     setData,
//     partyType,
//     setPartyType,
//     partyAccountID,
//     setPartyAccountID,
//     companyState,
//     companyGstType,
//     setRegistrationType,
//     setOriginalInvoiceNos,
//     setPartyDeliveryAddressEntity,
//     setPartyBillAddressEntity,
//     totNetAmt,
//     districtArr,
//     stateArr,
//     countryArr,
//     setBillingAddressDetails,
//     invoiceEntry,
//     setDeliveryAddressDetails,
//     setOpenResetModal,
//     setNewChangeValue,
//     setInitialState,
//     partyCategery, setPartyCategery
//   } = useStateList() || {};
//   let getCompany = useSelector(
//     (state) => state?.companyReducer?.companyDetails
//   );
//   let companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
//   const [stateName, setStateName] = useState("");
//   const [districtName, setDistrictName] = useState("");
//   const [countryName, setCountryName] = useState("");
//   const [stateDelName, setStateDelName] = useState("");
//   const [districtDelName, setDistrictDelName] = useState("");
//   const [countryDelName, setCountryDelName] = useState("");
//   const [accountBalance, setAccountBalance] = useState(0);
//   const [newPartyID, setNewPartyID] = useState("");
//   let stateValue = useSelector((state) => state);
//   const location = useLocation();
//   const debitLabels = {
//     partyName: "Customer/Supplier",
//     gstINName: "Customer/Supplier GSTIN",
//     seriesName: "Debit Note Series Name",
//     voucherName: "Debit Note Number",
//     voucherValue: "voucherNumber",
//     dateName: "Debit Note Date",
//     seriesValue: "seriesVouchers",
//     voucherType: "DebitInvoice",
//     orderNumberName: "Customer/Supplier Order Number",
//     voucherModalName: "Debit Note Number Settings",
//     orderDateName: "Customer/Supplier Order Date",
//   };

//   const creditLabels = {
//     partyName: "Customer/Supplier",
//     gstINName: "Customer/Supplier GSTIN",
//     seriesName: "Credit Note Series Name",
//     voucherName: "Credit Note Number",
//     voucherValue: "voucherNumber",
//     dateName: "Credit Note Date",
//     seriesValue: "seriesVouchers",
//     voucherType: "CreditInvoice",
//     orderNumberName: "Customer/Supplier Order Number",
//     voucherModalName: "Credit Note Number Settings",
//     orderDateName: "Customer/Supplier Order Date",
//   };

//   const salesLabel = {
//     partyName: "Customer Name",
//     gstINName: "Customer GSTIN",
//     seriesName: "Invoice Series Name",
//     voucherName: "Invoice Number",
//     voucherValue: "voucherNumber",
//     dateName: "Invoice Date",
//     seriesValue: "seriesVouchers",
//     voucherType: "SalesInvoice",
//     orderNumberName: "Customer Order Number",
//     voucherModalName: "Sales Invoice Number Settings",
//     orderDateName: "Customer Order Date",
//   };

//   const purchaseLabels = {
//     partyName: "Supplier Name",
//     gstINName: "Supplier GSTIN",
//     seriesName: "Voucher Series Name",
//     voucherName: "Voucher Number",
//     voucherValue: "voucherNumber",
//     dateName: "Voucher Date",
//     seriesValue: "seriesVouchers",
//     voucherType: "PurchaseInvoice",
//     orderNumberName: "Supplier Invoice Number",
//     voucherModalName: "Voucher Number Settings",
//     orderDateName: "Supplier Invoice Date",
//   };

//   const Type =
//     location?.pathname === "/adddebitnote" ||
//     location?.pathname === "/viewdebitnote" ||
//     location?.pathname === "/editdebitnote"
//       ? "DebitNote"
//       : location?.pathname === "/addcreditnote" ||
//         location?.pathname === "/viewcreditnote" ||
//         location?.pathname === "/editcreditnote"
//       ? "CreditNote"
//       : location?.pathname === "/addnewinvoicetax" ||
//         location?.pathname === "/viewnewinvoicetax" ||
//         location?.pathname === "/editnewinvoicetax"
//       ? "Sales"
//       : location?.pathname === "/addnewpurchasetax" ||
//         location?.pathname === "/viewnewpurchasetax" ||
//         location?.pathname === "/editnewpurchasetax"
//       ? "Purchase"
//       : "";

//   const invoiceLabels =
//     Type === "DebitNote"
//       ? debitLabels
//       : Type === "CreditNote"
//       ? creditLabels
//       : Type === "Sales"
//       ? salesLabel
//       : Type === "Purchase"
//       ? purchaseLabels
//       : {};

//   const displayAccountBalance = async (id) => {
//     try {
//       const res = await API.graphql(
//         graphqlOperation(getAccountBalance, { accountid: id })
//       );
//       if (res?.data?.getAccountBalance?.length > 0) {
//         setAccountBalance(res.data.getAccountBalance[0].accountbalance);
//       } else {
//         setAccountBalance(0);
//       }
//     } catch (error) {
//       console.log("Error fetching account balance:", error);
//     }
//   };
//   async function getInvoiceVouchers(Id, partyType, invoiceEntry) {
//     try {
//       let invNo = [];
//       let voucherNos = [];
//       const res = await API.graphql(
//         graphqlOperation(getPartyInvoices, {
//           partyid: Id,
//           partytypecd: partyType,
//         })
//       );
//       if (res?.data?.getPartyInvoices?.length > 0) {
//         if (partyType === "CUSTOMER") {
//           res?.data?.getPartyInvoices?.map((ele) => {
//             invNo.push({
//               label: ele.invoicenumber,
//               value: ele.invoiceid,
//               regType: "",
//               taxability: ele?.invoicetaxabletypecd,
//             });
//           });
//           if (invoiceEntry) {
//             let selected = [];
//             let array = invoiceEntry?.originalinvoicenumber.split(",");
//             array.map((ele) => {
//               invNo.map((subele) => {
//                 if (ele == subele.value) {
//                   selected.push({
//                     label: subele.label,
//                     value: subele.value,
//                     regType: subele.regType,
//                     taxability: subele?.taxability,
//                   });
//                 }
//               });
//             });

//             setData((prev) => ({
//               ...prev,
//               originalInvoiceNumber: selected,
//             }));
//           }

//           setOriginalInvoiceNos(invNo);
//         }
//         if (partyType === "SUPPLIER") {
//           res?.data?.getPartyInvoices?.map((ele) => {
//             voucherNos.push({
//               label: ele.vouchernumber,
//               value: ele.purchaseid,
//               regType: ele.partyregistrationtype,
//               taxability: ele?.purchasegsttypecd,
//             });
//           });
//           if (invoiceEntry) {
//             let selected = [];
//             let array = invoiceEntry?.originalinvoicenumber.split(",");
//             array.map((ele) => {
//               voucherNos.map((subele) => {
//                 if (ele == subele.value) {
//                   selected.push({
//                     label: subele.label,
//                     value: subele.value,
//                     regType: subele.regType,
//                     taxability: subele?.taxability,
//                   });
//                 }
//               });
//             });

//             setData((prev) => ({
//               ...prev,
//               originalInvoiceNumber: selected,
//             }));
//           }

//           setOriginalInvoiceNos(voucherNos);
//         }
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   }

//   async function getPartyBillAddressEntityDetails(objID, objType) {
//     try {
//       const resDetails = await API.graphql(
//         graphqlOperation(getPartyAddressEntity, {
//           objectid: objID,
//           objecttype: objType,
//         })
//       );
//       let Data = resDetails.data.getPartyAddressEntity?.[0];

//       setPartyBillAddressEntity(Data);
//       if (Data !== null) {
//         setData((prev) => ({
//           ...prev,
//           billingAddress: Data?.line1,
//         }));

//         let nameOfState = { label: "", value: "" };
//         stateArr.map((ele) => {
//           if (ele.code == resDetails.data.getPartyAddressEntity?.[0].statecode)
//             nameOfState = {
//               label: ele.label,
//               value: ele.value,
//               code: ele?.code,
//             };
//         });
//         setStateName(nameOfState);

//         let nameOfDistrict = { label: "", value: "" };
//         districtArr.map((ele) => {
//           if (ele.value == resDetails.data.getPartyAddressEntity?.[0].district)
//             nameOfDistrict = { label: ele.label, value: ele.value };
//         });
//         setDistrictName(nameOfDistrict);
//         let nameOfCountry = { label: "", value: "" };
//         countryArr.map((ele) => {
//           if (
//             ele.value == resDetails.data.getPartyAddressEntity?.[0].countrycode
//           )
//             nameOfCountry = { label: ele.label, value: ele.value };
//         });
//         setCountryName(nameOfCountry);

//         getDistrictsModal(

//           nameOfState.value,
//           resDetails.data.getPartyAddressEntity?.[0].district,

//           setBillingAddressDetails
//         );
//         getStatesModal(
//           resDetails.data.getPartyAddressEntity?.[0].countrycode,
//           resDetails.data.getPartyAddressEntity?.[0].statecode,
//           setBillingAddressDetails
//         );
//         setBillingAddressDetails((prev) => ({
//           ...prev,
//           billingAddress: Data?.line1?.replace(/\*/g, " "),
//           country: resDetails.data.getPartyAddressEntity?.[0].countrycode,
//           district: resDetails.data.getPartyAddressEntity?.[0].district,
//           states: resDetails.data.getPartyAddressEntity?.[0].statecode,
//           pincode: resDetails.data.getPartyAddressEntity?.[0].pincode,
//           countryCD: nameOfCountry,
//         }));
//         if (
//           invoiceEntry?.length === 0 &&
//           (Type === "CreditNote" || Type === "DebitNote")
//         ) {
//           setDeliveryAddressDetails((prev) => ({
//             ...prev,
//             deliveryAddress: Data?.line1?.replace(/\*/g, " "),
//             country: resDetails.data.getPartyAddressEntity?.[0].countrycode,
//             district: resDetails.data.getPartyAddressEntity?.[0].district,
//             states: resDetails.data.getPartyAddressEntity?.[0].statecode,
//             pincode: resDetails.data.getPartyAddressEntity?.[0].pincode,
//             countryCD: nameOfCountry,
//           }));
//           getDistrictsModal(

//             nameOfState?.value,
//             resDetails.data.getPartyAddressEntity?.[0].district,
//             setDeliveryAddressDetails
//           );
//           getStatesModal(
//             resDetails.data.getPartyAddressEntity?.[0].countrycode,
//             resDetails.data.getPartyAddressEntity?.[0].statecode,
//             setDeliveryAddressDetails
//           );
//         }
//       } else {
//         setData((prev) => ({
//           ...prev,
//           deliveryAddress: "",
//           billingAddress: "",
//         }));
//       }
//     } catch (e) {
//       console.log(e, "error");
//     }
//   }
//   async function getPartyDeliveryAddressDetails(objID, objType) {
//     const resPartyAddressEntityDetails = await API.graphql(
//       graphqlOperation(getPartyAddressEntity, {
//         objectid: objID,
//         objecttype: objType,
//       })
//     );

//     let partyAddressEntityData =
//       resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0];
//     setPartyDeliveryAddressEntity(partyAddressEntityData);
//     if (partyAddressEntityData !== null) {
//       setData((prev) => ({
//         ...prev,
//         deliveryAddress: partyAddressEntityData?.line1?.replace(/\*/g, " "),
//       }));

//       let nameOfState = { label: "", value: "" };
//       stateArr.map((ele) => {
//         if (
//           ele.code ==
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode
//         )
//           nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
//       });
//       setStateDelName(nameOfState);
//       let nameOfDistrict = { label: "", value: "" };
//       districtArr.map((ele) => {
//         if (
//           ele.value ==
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].district
//         )
//           nameOfDistrict = { label: ele.label, value: ele.value };
//       });
//       setDistrictDelName(nameOfDistrict);
//       let nameOfCountry = { label: "", value: "" };
//       countryArr.map((ele) => {
//         if (
//           ele.value ==
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0]
//             .countrycode
//         )
//           nameOfCountry = { label: ele.label, value: ele.value };
//       });
//       setCountryDelName(nameOfCountry);
//       getDistrictsModal(
//         nameOfState.value,
//         resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].district,
//         setDeliveryAddressDetails
//       );
//       getStatesModal(
//         resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0]
//           .countrycode,
//         resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode,
//         setDeliveryAddressDetails
//       );
//       setDeliveryAddressDetails((prev) => ({
//         ...prev,
//         deliveryAddress:
//           resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.line1?.replace(
//             /\*/g,
//             " "
//           ),
//         country:
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0]
//             .countrycode,
//         district:
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].district,
//         states:
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0]
//             .statecode,
//         pincode:
//           resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].pincode,
//         countryCD: nameOfCountry,
//       }));
//     } else {
//       setData((prev) => ({
//         ...prev,
//         deliveryAddress: "",
//         billingAddress: "",
//       }));
//     }
//   }
//   const handlePartyCategoryChange = async (partyValue) => {
//     try {
//       if (!partyValue) {
//         setData((prev) => ({
//           ...prev,
//           partyName: { label: "", value: "" },
//           errorStatus: { ...prev.errorStatus, partyName: true },
//           errorFields: {
//             ...prev.errorFields,
//             partyName: invoiceLabels.partyName + " name is required",
//           },
//         }));
//         return;
//       }
//       const resPartyMaster = await API.graphql(
//         graphqlOperation(getPartyMaster, {
//           partyid: partyValue,
//         })
//       );
//       if (resPartyMaster?.data?.getPartyMaster?.length > 0) {
//         const partyData = resPartyMaster.data.getPartyMaster?.[0];
//         let prevPlaceOfSupply = data?.placeOfSupply?.value;

//         const isTaxabilityValid = data?.taxability?.value !== "";
//         const isPartyCategoryValid =
//           data?.partyCategory !== "" &&
//           data.partyCategory !== partyData?.gstcategory;
//         const isCategoryMismatch =
//           (Type === "Sales" ? ["OC", "SEZ"] : ["UB", "OC"]).includes(
//             data?.partyCategory
//           ) ||
//           (Type === "Sales" ? ["OC", "SEZ"] : ["UB", "OC"]).includes(
//             partyData?.gstcategory
//           );

//         const isInvoiceOrAmountValid =
//           data?.originalInvoiceNumber?.length > 0 || totNetAmt > 0;
//         const isPartyNameChanged = partyValue !== data.partyName.value;
//         const isNoteType = Type === "DebitNote" || Type === "CreditNote";

//         const isPlaceOfSupplyChanged =
//           (prevPlaceOfSupply === 96 && partyData?.placeofsupply !== 96) ||
//           (partyData?.placeofsupply === 96 && prevPlaceOfSupply !== 96);

//         if (
//           (isTaxabilityValid && isPartyCategoryValid && isCategoryMismatch) ||
//           (isInvoiceOrAmountValid && isPartyNameChanged && isNoteType) ||
//           (isTaxabilityValid && isPlaceOfSupplyChanged)
//         ) {

//           setOpenResetModal(true);
//           let changeValue = {
//             label: partyData?.partydisplayname,
//             value: partyData?.partyid,
//             type: "party",
//           };
//           setNewChangeValue(changeValue);
//         } else {
//           partyOnchange(partyValue);
//         }
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   };
//   const partyOnchange = async (partyValue) => {
//     let listing = stateValue?.posListReducer?.posList?.listPlaceOfSupply;
//       let statesArray = listing?.map((element) => {
//         return {
//           label: `(${element?.statecode})   ${element?.statename}`,

//           value: element?.statecode,
//         };
//       });
//     if (!partyValue) {
//       setData((prev) => ({
//         ...prev,
//         partyName: { label: "", value: "" },
//         errorStatus: { ...prev.errorStatus, partyName: true },
//         errorFields: {
//           ...prev.errorFields,
//           partyName: invoiceLabels.partyName + " name is required",
//         },
//       }));
//       return;
//     }

//     try {
//       const resPartyMaster = await API.graphql(
//         graphqlOperation(getPartyMaster, {
//           partyid: partyValue,
//         })
//       );

//       if (resPartyMaster?.data?.getPartyMaster?.length > 0) {
//         const partyData = resPartyMaster.data.getPartyMaster[0];

//         let partyCategory = partyData?.gstcategory || "";

//         let partyAccID = partyData?.accountsid || "";
//         let gstin = partyData?.relatedpartygstdetails?.[0]?.gstin || "";
//         let creditLimit =
//           Number(partyData?.relatedpartycreditdetails?.[0]?.creditlimitamount) >
//           0
//             ? partyData?.relatedpartycreditdetails?.[0]?.creditlimitamount
//             : 0;
//         let creditPeriod =
//           Number(
//             partyData?.relatedpartycreditdetails?.[0]?.creditperiodduration
//           ) || 0;
//         let dueDate = moment(data.invoiceDate).add(creditPeriod, "days");
//         let tdsSection = partyData?.tdssection || "";
//         let tdsPercentage = partyData?.tdspercentage || "";
//         let billingCurrency = { label: "", value: "", sign: "", code: "" };

//         const partyName = {
//           label: partyData?.partydisplayname,
//           value: partyData?.partyid,
//           legalName: partyData?.partylegalname,
//           email: partyData?.email,
//           consigneeGSTIN: partyData?.deliveryconsigneegstin,
//           consigneeName: partyData?.deliveryconsigneename,
//           accountsID: partyData?.accountsid,
//           gstin,
//           placeOfSupply: partyData?.placeofsupply,
//           PartyTypeCd: partyData?.partytypecd,
//           creditPeriod,
//           gstCategory: partyCategory,
//           billingCurrency:
//             partyData?.relatedpartycreditdetails?.[0]?.billingcurrency,
//           tdsSection,
//           tdsPercentage,
//           creditLimit,
//         };

//         const foundCurrency = billingCurrencyOptions.find(
//           (currency) =>
//             currency.value ===
//             partyData?.relatedpartycreditdetails?.[0]?.billingcurrency
//         );
//         if (foundCurrency) {
//           billingCurrency = { ...foundCurrency };
//         }

//         let placeOfSupply = { label: "", value: "" };
//         let companyPlaceOfSupply = { label: "", value: "" };
//         statesArray?.map((state) => {
//           if (state.value == partyData?.placeofsupply) {
//             placeOfSupply = { label: state.label, value: state.value };
//           }
//           if (state.value == companyState) {
//             companyPlaceOfSupply = { label: state.label, value: state.value };
//           }
//         });

//         if (Type === "Purchase" && partyCategory === "RBCS") {
//           setRegistrationType(1);
//         } else {
//           setRegistrationType(companyGstType);
//         }
//         setPartyCategery(partyCategery);
//         setPartyType(partyData?.partytypecd || "");
//         setPartyAccountID(partyAccID);
//         displayAccountBalance(partyAccID);

//         if (Type === "CreditNote" || Type === "DebitNote") {
//           getInvoiceVouchers(partyValue, partyData?.partytypecd);
//         }

//         getPartyBillAddressEntityDetails(partyValue, "PartyBilling");
//         if (partyData?.partytypecd === "CUSTOMER") {
//           getPartyDeliveryAddressDetails(partyValue, "PartyDelivery");
//         }
//         getCurrentCurrencyRate(billingCurrency.code);

//         setData((prev) => ({
//           ...prev,
//           partyName,
//           partyCategory,
//           gstin,
//           consigneeGST: partyData?.deliveryconsigneegstin || gstin,
//           consigneeName: partyData?.deliveryconsigneename || partyName?.label,
//           partyCreditLimit: creditLimit,
//           placeOfSupply:
//             partyCategory === "Overseas"
//               ? { label: "FOREIGN COUNTRY", value: 96 }
//               : placeOfSupply.value !== "" && companyType !== 3
//               ? placeOfSupply
//               : companyPlaceOfSupply,
//           creditPeriod,
//           dueDate,
//           currency: billingCurrency,
//           tdsOptions: tdsSection,
//           tdsPercent: tdsPercentage,
//           errorStatus: {
//             ...prev.errorStatus,
//             partyName: false,
//             placeOfSupply: false,
//           },
//           errorFields: {
//             ...prev.errorFields,
//             partyName: "",
//             placeOfSupply: "",
//           },
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching party details:", error);
//     }
//   };

//   async function getStatesModal(code, state, setAddressDetails) {
//     try {
//       let nameOfstate = { label: "", value: "", code: "" };
//       const cities = await API.graphql(
//         graphqlOperation(getCodeTranslation, { codetype: code })
//       );
//       if (cities?.data?.getCodeTranslation != null) {
//         let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
//           return {
//             label: element.codetext,
//             value: `${element.codetext}District`,
//             code: element?.statecode,
//           };
//         });

//         statesArray.map((ele) => {
//           if (ele.code == state) {
//             nameOfstate = {
//               label: ele.label,
//               value: ele.value,
//               code: ele?.code,
//             };
//           }
//         });

//         setAddressDetails((prev) => ({
//           ...prev,
//           stateCD: nameOfstate,
//         }));
//       }
//     } catch (error) {}
//   }
//   async function getDistrictsModal(state, district, setAddressDetails) {
//     try {
//       let nameOfDistrict = { label: "", value: "" };
//       const cities = await API.graphql(
//         graphqlOperation(getCodeTranslation, { codetype: state })
//       );
//       if (cities?.data?.getCodeTranslation != null) {
//         let disArray = (cities?.data?.getCodeTranslation).map((element) => {
//           return {
//             label: element.codetext,
//             value: `${element.codetext}District`,
//           };
//         });
//         console.log("disArray", disArray);

//         disArray.map((ele) => {
//           if (ele.value === district) {
//             nameOfDistrict = { label: ele.label, value: ele.value };
//           }
//         });

//         setAddressDetails((prev) => ({
//           ...prev,
//           districtCD: nameOfDistrict,
//         }));
//       }
//     } catch (error) {}
//   }
//   async function getCurrentCurrencyRate(code) {
//     try {
//       const response = await axios.get(
//         `https://api.exchangerate-api.com/v4/latest/${code}`
//       );
//       if (response.data.rates.INR !== null) {
//         setData((prev) => ({
//           ...prev,
//           currencyRate: Number(response.data.rates.INR).toFixed(2),
//         }));
//         if (setInitialState) {
//           setInitialState((prev) => ({
//             ...prev,
//             currencyRate: Number(response.data.rates.INR).toFixed(2),
//           }));
//         }
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   }

//   return {
//     partyType,
//     partyAccountID,
//     partyOnchange,
//     getPartyDeliveryAddressDetails,
//     getPartyBillAddressEntityDetails,
//     displayAccountBalance,
//     getInvoiceVouchers,
//     getStatesModal,
//     getDistrictsModal,
//     getCurrentCurrencyRate,
//     accountBalance,
//     stateName,
//     districtName,
//     countryName,
//     stateDelName,
//     districtDelName,
//     countryDelName,
//     setStateName,
//     setDistrictName,
//     setCountryName,
//     setStateDelName,
//     setDistrictDelName,
//     setCountryDelName,
//     setAccountBalance,
//     newPartyID,
//     setNewPartyID,
//     handlePartyCategoryChange,
//   };
// };

// export default usePartyDetails;
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import { getPartyMaster } from "../../../graphql";

function usePartyDetails({ Id }) {
  const [paryDetails, setPartyDetails] = useState({});
  const getPartyDetails = async () => {
    try {
      const res = await API.graphql(
        graphqlOperation(getPartyMaster, {
          partyid: Id,
        })
      );
      if (res?.data?.getPartyMaster?.length > 0) {
        const partyData = res.data.getPartyMaster?.[0];
        setPartyDetails(partyData);
      }else{
        setPartyDetails({});
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  
  useEffect(() => {
    if(Id && !isNaN(Id)){
    getPartyDetails();
    }
  }, [Id])
  return { getPartyDetails, paryDetails };
}

export default usePartyDetails;
